import React from "react";
import Carousel from "./Carousel";
import Seo from "./Head";
import Anteojo from "./Anteojo";

export const ItemDetail = ({ itemDetail }) => {
  if (!itemDetail) return null;

  const consultarPorWhatsApp = () => {
    // 1. Detectamos plataforma
    const plataforma = window.innerWidth < 990 ? "api" : "web";
    const telefono = "5493774411192";

    // 2. Usamos el link LIMPIO (el .htaccess se encarga del resto)
    const linkProducto = `https://optimarketok.com.ar/detalle/${itemDetail.id}/`;

    // 3. Armamos el mensaje
    const mensaje = encodeURIComponent(
      `Hola *Optimarket OK!* 👓\n\n` +
        `Me interesa este modelo\n\n` +
        `Precio: ${new Intl.NumberFormat("es-AR", {
          style: "currency",
          currency: "ARS",
          maximumFractionDigits: 0, // <--- Esto quita los centavos
        }).format(itemDetail.precio)}\n\n` +
        `Link: ${linkProducto}`,
    );

    // 4. Abrimos WhatsApp
    const urlFinal = `https://${plataforma}.whatsapp.com/send?phone=${telefono}&text=${mensaje}`;
    window.open(urlFinal, "_blank");
  };

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };

  return (
    <>
      <Seo
        title={itemDetail?.titulo}
        description={itemDetail?.precio}
        image={itemDetail?.imagenes?.[0]?.url || ""}
        pathSlug={window.location.href}
      />

      <div className="row">
        <div className="card col-12 col-md-6 ps-md-5 pe-md-5 mt-md-3">
          {itemDetail?.imagenes && (
            <Carousel settings={settings}>
              {itemDetail.imagenes.map((img, index) => (
                <div key={index}>
                  <img
                    src={img.url}
                    alt={itemDetail.titulo}
                    className="img-fluid"
                  />
                </div>
              ))}
            </Carousel>
          )}
        </div>

        <div className="card pe-3 ps-3 datos mt-3 col-12 col-md-6">
          <div>
            <h1>{itemDetail?.titulo}</h1>
            <h4 className="gris">
              {itemDetail?.categoria} / stock: {itemDetail?.stock}
            </h4>
            <h4 className="text-md-start mt-3">
              {new Intl.NumberFormat("es-AR", {
                style: "currency",
                currency: "ARS",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }).format(itemDetail?.precio || 0)}
            </h4>
            <div
              className="mt-3"
              dangerouslySetInnerHTML={{
                __html: itemDetail?.descripcion || "",
              }}
            />
          </div>

          <div className="mt-3 mb-3">
            <Anteojo medidas={itemDetail?.medidas}></Anteojo>
          </div>

          <div className="mt-3">
            <h4>
              <i className="bi bi-credit-card-2-back me-2"></i>Todos los medios
              de pago
            </h4>
            <h4>
              <i className="bi bi-truck me-2"></i>Envíos a todo el país!
            </h4>
            <h4>
              <i className="bi bi-person-check me-2"></i>Asesoramiento
              personalizado
            </h4>
          </div>

          <h4 className="text-center text-md-start mt-4">
            <div id="agregarAlCarrito">
              <div
                className="boton me-md-2 btnWhat"
                onClick={consultarPorWhatsApp}
                style={{ cursor: "pointer" }}
              >
                Consultar <i className="bi bi-whatsapp"></i>
              </div>
            </div>
          </h4>
        </div>
      </div>
    </>
  );
};
